import { render } from "./Calibers.vue?vue&type=template&id=7d5bd963&scoped=true"
import script from "./Calibers.vue?vue&type=script&lang=ts"
export * from "./Calibers.vue?vue&type=script&lang=ts"

import "./Calibers.vue?vue&type=style&index=0&id=7d5bd963&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-7d5bd963"

export default script